import { render, staticRenderFns } from "./settlementProject.vue?vue&type=template&id=79ecd8c2&scoped=true&"
import script from "./settlementProject.vue?vue&type=script&lang=js&"
export * from "./settlementProject.vue?vue&type=script&lang=js&"
import style0 from "./settlementProject.vue?vue&type=style&index=0&id=79ecd8c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ecd8c2",
  null
  
)

export default component.exports